var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    svg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    width: "252px",
    height: "69px",
    viewBox: "0 0 128 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2990fb",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1200ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.167;0.5;0.668;1",
    values: "0.3;1;1;0.3;0.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2990fb",
    cx: 110.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1200ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.334;0.5;0.835;1",
    values: "0.3;0.3;1;1;0.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2990fb",
    cx: 64,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1200ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.167;0.334;0.668;0.835;1",
    values: "0.3;0.3;1;1;0.3;0.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.037b207da6845c2744a9ed1f81d10b55.svg";
export { ForwardRef as ReactComponent };